var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "pb-0" }, [
        _c("h3", { staticClass: "checkout-section-title" }, [
          _vm._v(_vm._s(_vm.$t("checkout.deliveryTitle")))
        ])
      ]),
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("checkout.email"),
                      rules: [_vm.rules.required, _vm.rules.email],
                      "error-messages": _vm.error,
                      loading: _vm.loading,
                      error: _vm.error !== null,
                      "append-icon": _vm.success ? "mdi-check" : "",
                      type: "email",
                      name: "email"
                    },
                    on: { focus: _vm.onEmailFocus },
                    model: {
                      value: _vm.form.customer.email,
                      callback: function($$v) {
                        _vm.$set(_vm.form.customer, "email", $$v)
                      },
                      expression: "form.customer.email"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "12" } },
                [
                  _c("v-checkbox", {
                    staticClass: "mt-0",
                    attrs: { label: _vm.$t("checkout.isCompany") },
                    model: {
                      value: _vm.company,
                      callback: function($$v) {
                        _vm.company = $$v
                      },
                      expression: "company"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.company
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("checkout.company"),
                          required: "",
                          rules: [_vm.rules.required]
                        },
                        model: {
                          value: _vm.form.customer.companyName,
                          callback: function($$v) {
                            _vm.$set(_vm.form.customer, "companyName", $$v)
                          },
                          expression: "form.customer.companyName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.company
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("checkout.singleVat"),
                          required: "",
                          rules: [_vm.rules.required]
                        },
                        model: {
                          value: _vm.form.customer.companyCRN,
                          callback: function($$v) {
                            _vm.$set(_vm.form.customer, "companyCRN", $$v)
                          },
                          expression: "form.customer.companyCRN"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("checkout.companyVat"),
                          required: ""
                        },
                        model: {
                          value: _vm.form.customer.companyVAT,
                          callback: function($$v) {
                            _vm.$set(_vm.form.customer, "companyVAT", $$v)
                          },
                          expression: "form.customer.companyVAT"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.company
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("checkout.street"),
                          required: "",
                          rules: [_vm.rules.required]
                        },
                        model: {
                          value: _vm.form.customer.address.street,
                          callback: function($$v) {
                            _vm.$set(_vm.form.customer.address, "street", $$v)
                          },
                          expression: "form.customer.address.street"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.company
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("checkout.city"),
                          required: "",
                          rules: [_vm.rules.required]
                        },
                        model: {
                          value: _vm.form.customer.address.town,
                          callback: function($$v) {
                            _vm.$set(_vm.form.customer.address, "town", $$v)
                          },
                          expression: "form.customer.address.town"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("checkout.zip"),
                          required: "",
                          rules: [_vm.rules.required]
                        },
                        model: {
                          value: _vm.form.customer.address.zip,
                          callback: function($$v) {
                            _vm.$set(_vm.form.customer.address, "zip", $$v)
                          },
                          expression: "form.customer.address.zip"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.checkingCustomer } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64", color: "primary" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }